"use client";

import { AnimatePresence } from "framer-motion";
import DefaultView from "./default-view";
import { CarpetSectionProps } from "../types/common";

type Props = {
  data: CarpetSectionProps;
};

export default function Carpets({ data }: Props) {
  return (
    <>
      <AnimatePresence mode="wait">
        <DefaultView data={data} />
      </AnimatePresence>
    </>
  );
}
